import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'

import Award from './Award'

import s from './Awards.module.scss'
import HorizontalWapper from '../HorizontalWrapper'
const cn = classNames.bind(s)

const _ = {
  maxLength: 3,
}

const Awards = ({ data }) => {
  const { fields } = data

  return (
    <HorizontalWapper>
      <div className={cn('awards')}>
        {fields.slice(0, _.maxLength).map((field, i) => (
          <Award key={i} data={field} />
        ))}
      </div>
    </HorizontalWapper>
  )
}

Awards.propTypes = {
  data: PropTypes.object,
}

export default Awards
